<template>
  <div class="body">
    <div class="admin-dashboard">
      <SideMenu />
      <div class="content-area">
        <header>
          <div class="line line1"></div>
          <div class="line line2"></div>

        
          <div class="user-profile">
            <i class="bi bi-person-circle" @click="toggleMenu"></i>
            <transition name="fade">
              <div class="user-menu" v-if="menuVisible">
                <ul>
              
                  <li>
                    <router-link to="/admin/perfil" class="link">
                      <i class="bi bi-person-fill"></i> Perfil
                    </router-link>
                  </li>
                
                  <li @click="logout">
                    <i class="bi bi-box-arrow-right"></i> Cerrar sesión
                  </li>
                </ul>
              </div>
            </transition>
          </div>
        </header>
        <div class="main-content">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SideMenu from "@/components/SideMenu.vue";

export default {
  components: {
    SideMenu,
  },
  data() {
    return {
      menuVisible: false,
    };
  },
  methods: {
    toggleMenu() {
      this.menuVisible = !this.menuVisible;
    },
    logout() {
      localStorage.clear(); 
      this.$router.push("/InicioSesion"); 
    },
  },
};
</script>

<style scoped>
.admin-dashboard {
  display: flex;
}

.content-area {
  margin-left: 200px;
  padding: 20px;
  width: calc(100% - 200px);
}

header {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0;
  padding: 0;
}

.line {
  width: 100%;
  height: 35px;
  margin: 0;
}

.line1 {
  background-color: #97c335;
}

.line2 {
  background-color: #29b39c;
}

.user-profile {
  position: absolute;
  top: 48px;
  right: 28px;
  cursor: pointer;
  color: #ffffff;
  font-size: 30px;
}

.user-profile:hover .user-menu {
  display: block;
}

.user-menu {
  display: none;
  position: absolute;
  top: 40px;
  right: 0;
  background-color: rgb(97, 94, 94);
  border: 1px solid #272626;
  border-radius: 4px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  font-size: medium;
  z-index: 1000;
  width: 200px; /* Ajustar ancho del menú */
}

.user-menu ul {
  list-style: none;
  margin: 0;
  padding: 10px;
}

.user-menu li {
  padding: 8px 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.user-menu li:hover {
  background-color: #29b39c;
}

.user-menu i {
  margin-right: 8px;
}

.link {
  color: #fff;
  text-decoration: none;
}

.link:hover {
  color: #29b39c;
}
</style>
